import React from "react";
import { Button, Checkbox, Form, Input, Radio, Select } from "antd";
import { getMonetizationTemplates } from "../../../../common/redux/actions/fieldsActions";
import { connect } from "react-redux";

const { Group } = Radio;

class MonetizationTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      templateToggle: false,
      selectedTemplate: null
    };
  }

  componentDidMount() {
    if (!this.props.templates) {
      this.props.getMonetizationTemplates();
    }
  }

  componentDidUpdate() {
    if (!this.props.templates) {
      this.props.getMonetizationTemplates();
    }
    if (this.state.templateToggle) {
      this.props.toggleMonetizationFields(!this.state.templateToggle);
    } else {
      this.props.toggleMonetizationFields(!this.state.templateToggle);
    }
  }

  toggleMonetization = e => {
    this.setState({ templateToggle: e.target.value });
  };

  changeTemplate = value => {
    const template = this.props.templates.find(
      item => item.monetizationTemplateName === value
    );
    const obj = {
      kp1p: template.kp1p,
      kp1t: template.kp1t,
      kp2p: template.kp2p,
      kp2t: template.kp2t,
      kp3p: template.kp3p,
      kp3t: template.kp3t,
      kp4p: template.kp4p,
      kp4t: template.kp4t,
      kz1p: template.kz1p,
      kz1t: template.kz1t,
      kz2p: template.kz2p,
      kz2t: template.kz2t,
      kz3p: template.kz3p,
      kz3t: template.kz3t,
      kz4p: template.kz4p,
      kz4t: template.kz4t,
      sh1: template.sh1,
      sh2: template.sh2,
      sh3: template.sh3,
      t2: template.t2,
      t4: template.t4,
      t6: template.t6,
      t7: template.t7,
      t8: template.t8,
      t9: template.t9,
      monetizationTemplateName: template.monetizationTemplateName
    };
    this.props.form.setFieldsValue(obj);
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { disabled, templates } = this.props;

    return (
      <>
        <Form.Item hidden>
          {getFieldDecorator("monetizationIsPassed")(<Checkbox />)}
        </Form.Item>

        {!disabled && (
          <div className="offer-card__item double-margin monetization-template">
            <span className="label">Монетизация:</span>
            <Form.Item>
              {getFieldDecorator("isMonetizationTemplate", {
                initialValue: false
              })(
                <Group
                  size="medium"
                  disabled={this.props.monetizationSectionPass}
                  onChange={this.toggleMonetization}
                >
                  <Radio.Button value={true}>Шаблон</Radio.Button>
                  <Radio.Button value={false}>Без шаблона</Radio.Button>
                </Group>
              )}
            </Form.Item>
            <Button
              type="link"
              style={{ marginLeft: 186 }}
              onClick={this.props.passMonetizationSection}
            >
              {this.props.monetizationSectionPass
                ? "Заполнить монетизацию"
                : "Пропустить монетизацию"}
            </Button>
          </div>
        )}

        {(getFieldValue("isMonetizationTemplate") && (
          <div className="offer-card__item">
            <span className="label">Шаблон:</span>
            <Form.Item>
              {getFieldDecorator("monetizationTemplateName", {
                rules: [
                  {
                    required: true,
                    message: "Поле, обязательное для заполнения"
                  }
                ]
              })(
                <Select
                  style={{ width: 224 }}
                  placeholder={
                    templates && templates.length > 0
                      ? "Выберите шаблон"
                      : "У вас нет шаблонов"
                  }
                  disabled={
                    disabled ||
                    !templates ||
                    (templates && !templates.length > 0)
                  }
                  onChange={this.changeTemplate}
                >
                  {templates.map(item => {
                    return (
                      <Select.Option
                        key={item.id}
                        value={item.monetizationTemplateName}
                      >
                        {item.monetizationTemplateName}
                      </Select.Option>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
          </div>
        )) || (
          <div className="no-template">
            {!disabled && !this.props.monetizationSectionPass && (
              <div className="offer-card__item">
                <span
                  className="offer-card__non-label"
                  style={{ paddingLeft: "208px" }}
                >
                  <Form.Item>
                    {getFieldDecorator("monetizationTemplateNameCheck", {
                      valuePropName: "checked"
                    })(
                      <Checkbox disabled={disabled}>
                        Сохранить как новый шаблон
                      </Checkbox>
                    )}
                  </Form.Item>
                </span>
              </div>
            )}
            {getFieldValue("monetizationTemplateNameCheck") ? (
              <div className="offer-card__item">
                <span className="label">
                  <span>Наименование шаблона:</span>
                </span>
                <Form.Item>
                  {getFieldDecorator("monetizationTemplateName", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: 224 }}
                      disabled={!getFieldValue("monetizationTemplateNameCheck")}
                    />
                  )}
                </Form.Item>
              </div>
            ) : null}
          </div>
        )}
      </>
    );
  }
}

export default connect(
  state => ({
    templates: state.Common.Filters.monetizationTemplates
  }),
  {
    getMonetizationTemplates
  }
)(MonetizationTemplates);
